<template>
  <div id="menu">
    <div id="menu-content">
      <div class="profile-image">
        <img alt="Amy Soetopo" src="../assets/amy.jpg" id="amy">
      </div>
      <div id="profile">
        <ul>
          <li><strong>Amy Soetopo</strong></li>
          <li>Sr. Software Developer</li>
        </ul>
      </div>
      <div class="social">
        <ul>
          <li>
            <a href="https://www.linkedin.com/in/astopo/">
              <img alt="LinkedIn" src="../assets/linkedin.png">
            </a>
          </li>
          <li>
            <a href="https://github.com/astopo">
              <img alt="Github" src="../assets/github.png">
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div id="nav">
      <ul>
        <li>
          <router-link to="/">
            Hello, world
            <div class="arrow-wrapper">
              <div class="arrow-left"></div>
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/experience">
            Experience
            <div class="arrow-wrapper">
              <div class="arrow-left"></div>
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/projects">
            Projects
            <div class="arrow-wrapper">
              <div class="arrow-left"></div>
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/stack">
          Stack
            <div class="arrow-wrapper">
              <div class="arrow-left"></div>
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/contact">
            Contact
            <div class="arrow-wrapper">
              <div class="arrow-left"></div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
  color: #dddddd;
}

p {
  color: #ddd;
}

#menu-content {
  padding: 2rem;
}

.router-link-exact-active {
  width: 100%;
  height: 100%;
  display: inline-block;
  padding: 0.5rem 0;
  text-decoration: none;
}

.router-link-exact-active {
  background: #c7373d !important;
}

#menu #nav a {
  text-decoration: none;
  color: #ddd;
}

#nav ul li {
  padding: 0;
}

#nav ul li a {
  padding: 0.5rem 0;
  width: 100%;
  height: 100%;
  display: block;
  cursor: default;
  background: #222;
  border-bottom: 2px solid #191818;
  transition: 0.3s ease;
  font-weight: normal;
}

#nav ul li a:hover {
  cursor: pointer;
}

.router-link-exact-active,
#menu #nav ul li a:hover {
  background: #c7373d;
}

#nav li a .arrow-wrapper {
  display: none;
}

#nav .router-link-exact-active .arrow-wrapper,
#nav li:hover .arrow-wrapper {
  display: block;
}

.social img {
  width: 25px;
  height: 25px;
}

.social li {
  display: inline-block;
}

#amy {
  border-radius: 50%;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
}
@media (max-width: 48em) {
  .profile-image img {
    display: none;
  }
}

</style>
